import { logoBase64 } from "../../../info-technology-process/repair-tools/base64";
import ExcelJS from "exceljs";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import * as FileSaver from "file-saver";
import _ from "lodash";

export function isNoiBai(eDepartment: string) {
  return ["Chi nhánh Nội Bài".toLowerCase(), "Chi nhánh Đà Nẵng".toLowerCase()].includes(eDepartment?.toLowerCase());
}

function breakLine(ws: any, row: number) {
  ws.addRow([]);
}

function makeBold(ws: any, rowIndex: number, colIndex: number) {
  ws.getCell(rowIndex, colIndex).value = {
    richText: [
      {
        font: {
          bold: true,
        },
        text: ws.getCell(rowIndex, colIndex).text,
      },
    ],
  };
}

export function exportExcel(record: any) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  const imageId = workbook.addImage({
    base64: logoBase64,
    extension: "png",
  });

  worksheet.addImage(imageId, "A1:D3");
  worksheet.addRow(["", "", "", "", "Biểu mẫu", `Mã số: ${record.fields.eIssueNumber}`]);
  worksheet.addRow(["", "", "", "", "PHIẾU THAY ĐỔI NHÂN SỰ", `Lần ban hành: ${record.fields.eIssueTimes}`]);

  worksheet.addRow(["", "", "", "", "", `Ngày hiệu lực:  ${getDDMMYYYFormat(record.fields.eIssueEffectiveDate)}`]);

  breakLine(worksheet, 1);

  worksheet.addRow([
    "STT",
    "Nhân sự/mã NV đã đăng ký",
    "Nhân sự/mã NV thay thế/bổ sung",
    "Cơ quan/Đơn vị",
    "Lý do thay đổi",
    "Ghi chú",
  ]);

  for (const [index, item] of JSON.parse(record.fields.eContent).entries()) {
    worksheet.addRow([index + 1, item.registerPesonel, item.replacePersonel, item.department, item.reason, item.note]);
  }

  breakLine(worksheet, 2);

  worksheet.addRow(["Thủ trưởng đơn vị đề nghị", "", "", "Trưởng phòng TCNL", "", "", "Tổng Giám đốc", "", ""]);

  let currentRowIdx = worksheet.rowCount;

  makeBold(worksheet, currentRowIdx, 1);
  makeBold(worksheet, currentRowIdx, 4);
  makeBold(worksheet, currentRowIdx, 7);

  worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, 3);
  worksheet.mergeCells(currentRowIdx, 4, currentRowIdx, 6);
  worksheet.mergeCells(currentRowIdx, 7, currentRowIdx, 9);

  breakLine(worksheet, 3);

  worksheet.addRow(["Họ và tên: ", "", "", "Họ và tên: ", "", "", "Họ và tên: ", "", ""]);

  currentRowIdx = worksheet.rowCount;

  makeBold(worksheet, currentRowIdx, 1);
  makeBold(worksheet, currentRowIdx, 4);
  makeBold(worksheet, currentRowIdx, 7);
  makeBold(worksheet, 1, 6);
  makeBold(worksheet, 2, 6);
  makeBold(worksheet, 3, 6);

  makeBold(worksheet, 1, 5);
  makeBold(worksheet, 2, 5);

  for (const i of _.range(6)) {
    makeBold(worksheet, 5, i + 1);
  }

  worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, 3);
  worksheet.mergeCells(currentRowIdx, 4, currentRowIdx, 6);
  worksheet.mergeCells(currentRowIdx, 7, currentRowIdx, 9);

  worksheet.addRow(["Ngày: ", "", "", "Ngày: ", "", "", "Ngày: ", "", ""]);

  currentRowIdx = worksheet.rowCount;

  worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, 3);
  worksheet.mergeCells(currentRowIdx, 4, currentRowIdx, 6);
  worksheet.mergeCells(currentRowIdx, 7, currentRowIdx, 9);

  makeBold(worksheet, currentRowIdx, 1);
  makeBold(worksheet, currentRowIdx, 4);
  makeBold(worksheet, currentRowIdx, 7);

  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(
      blob,
      `${
        isNoiBai(record.fields.eDepartment) ? "BM-Phieu thay doi nhan su NBA-DAD" : "BM-Phieu thay doi nhan su KCQ-TSN"
      } - ${getDDMMYYYFormat(new Date())}`,
    );
  });
}
